import React from 'react';
import ColorPicker from './index';
import { Accordion } from 'semantic-ui-react';
import { useTextResources } from '../../../language';
import './style.css';
import PropTypes from 'prop-types';

const colors = [
  '#4D4D4D',
  '#999999',
  '#FFFFFF',
  '#F44E3B',
  '#FE9200',
  '#FCDC00',
  '#DBDF00',
  '#A4DD00',
  '#68CCCA',
  '#73D8FF',
  '#AEA1FF',
  '#FDA1FF',
  '#333333',
  '#808080',
  '#cccccc',
  '#D33115',
  '#E27300',
  '#FCC400',
  '#B0BC00',
  '#68BC00',
  '#16A5A5',
  '#009CE0',
  '#7B64FF',
  '#FA28FF',
  '#000000',
  '#666666',
  '#B3B3B3',
  '#9F0500',
  '#C45100',
  '#FB9E00',
  '#808900',
  '#194D33',
  '#0C797D',
  '#0062B1',
  '#653294',
  '#AB149E',
];

export default function ColorPickerExtended({
  onChangeColor,
  color,
  children,
  ...rest
}) {
  const text = useTextResources();

  const moreColors = {
    key: 'morecolors',
    title: text('MoreColors'),
    content: {
      content: (
        <ColorPicker
          color={color}
          triangle='hide'
          width='168px'
          onChangeColor={onChangeColor}
          colors={colors}
          type='Compact'
          {...rest}
        />
      ),
    },
  };

  return (
    <div style={{ padding: '1em' }} className='calendar-color-picker'>
      <ColorPicker
        triangle='hide'
        width='240px'
        color={color}
        onChangeColor={onChangeColor}
        {...rest}
      />
      <Accordion panels={[moreColors]} />
      {children}
    </div>
  );
}
ColorPickerExtended.propTypes = {
  onChangeColor: PropTypes.func,
  color: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
